import * as PlaybackStateActions from "actions/PlaybackStateActions";
import getCanControlVolume from "selectors/device/getCanControlVolume";
import getCanInitiallyAutoplay from "selectors/device/getCanInitiallyAutoplay";
import getDuration from "selectors/chapter/getDuration";
import getShowControls from "selectors/getShowControls";
import getPlaybackState from "selectors/chapter/getPlaybackState";
import MobileChapterControls from "components/MobileChapterControls";
import { connect } from "react-redux";
import getIsSubchapter from "selectors/getIsSubchapter";
import getHasSubchapter from "selectors/getHasSubchapter";
import * as UserInteractionActions from "actions/UserInteractionActions";
import { compose, mapProps, withProps } from "recompose";
import omit from "lodash/fp/omit";
import { AnalyticsActions } from "utils/Analytics";

const mapStateToProps = (state, ownProps) => {
  const playbackState = getPlaybackState(state, ownProps);
  //console.log("MobileChapterControlsContainer.controlsInactive", getControlsInactive(state, ownProps));
  let effectiveWaitingForInitialPlay = false;
  if (
    !state.playerOptions.autoplay &&
    state.playerOptions.embedded &&
    getCanInitiallyAutoplay(state, ownProps)
  ) {
    effectiveWaitingForInitialPlay =
      !state.userInteraction.receivedUserInteraction;
  }

  const topLevelChapterCount = state.story.topLevelChapters.length;

  return {
    controlsMode:
      !getShowControls(state, ownProps) &&
      !state.inactivity.compactControls &&
      ownProps.active
        ? "compact"
        : getShowControls(state, ownProps)
        ? "full"
        : null,
    canControlVolume: getCanControlVolume(state, ownProps),
    duration: getDuration(state, ownProps),
    hasSubchapter: getHasSubchapter(state, ownProps),
    playing: playbackState.playing,
    showChapterNavigationMarkers:
      !getIsSubchapter(state, ownProps) &&
      topLevelChapterCount !== 1 &&
      state.playerOptions.chapterNavigationButtons !== "hide",
    showCoutdownTimerInControls:
      state.playerOptions.showCoutdownTimerInControls,
    showSettingsMenu: state.playerOptions.showSettingsMenu,
    showSeekButtons: state.playerOptions.showSeekButtons,
    time: playbackState.time,
    waitingForInitialPlay: effectiveWaitingForInitialPlay,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onPlayButtonClick: (currentlyPlaying) =>
    dispatch(
      PlaybackStateActions.changePlaybackState(ownProps, {
        playing: !currentlyPlaying,
        userInitiatedPause: currentlyPlaying,
      }),
    ),
  onUserInteractionInitiatedPlayback: () =>
    dispatch(UserInteractionActions.receivedUserInteraction()),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onPlayButtonClick: () => {
    AnalyticsActions.playOrPause(ownProps);

    dispatchProps.onPlayButtonClick(stateProps.playing);
    if (stateProps.waitingForInitialPlay) {
      dispatchProps.onUserInteractionInitiatedPlayback();
    }
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withProps(({ active, chapterId, hasSubchapter }) => ({
    // Create a `key` to forcibly remount `MobileChapterControls` based on the
    // chapter id and the active state. `MobileChapterControls` uses
    // `CSSTransitionGroup` to animate the chapter controls and the playback
    // progress control (shown during periods of inactivity). There are three
    // behaviors for css transition groups: `appear`, `enter`, and `leave`. If
    // we don't unmount this component when `active` changes, then the component
    // will mount with `active=false`, show no controls, re-render when `active`
    // is set to `true`, and then perform the `enter` animation because a
    // component is entering (as opposed to using `appear` because it existed on
    // mount). This will ensure that chapter transitions show the same state of
    // the controls. We also use `hasSubchapter` beacuse we explicitly want to
    // NOT unmount the parent chapter's controls when we show a subchapter
    // because we _do_ want to animate those back in when the subchapter
    // completes.
    key: `${chapterId}-${active || hasSubchapter ? "active" : "inactive"}`,
  })),
  mapProps((props) => omit(["hasSubchapter", "active"], props)),
)(MobileChapterControls);
